module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "grid grid-cols-12 gap-3 mt-5"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto flex col-span-12"
  }, [_c('router-link', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2 mx-auto",
    attrs: {
      "to": "/admin/business/suppliers"
    }
  }, [_vm._v("\n          Regresar\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 md:col-span-12 box bg-white content"
  }, [(_vm.current.socialreasons.length) ? _c('div', {
    staticClass: "intro-y flex flex-col-reverse mt-3 sm:flex-row items-center"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-2"
  }, [_vm._v("\n          Razones Sociales Asignadas\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-3 mt-5"
  }, _vm._l((_vm.current.socialreasons), function(socialreason, index) {
    return _c('div', {
      key: index,
      staticClass: "intro-y col-span-12 md:col-span-6"
    }, [_c('div', {
      staticClass: "box bg-theme-1 text-white"
    }, [_c('div', {
      staticClass: "flex flex-col lg:flex-row items-center p-5 border-b border-gray-200"
    }, [_c('div', {
      staticClass: "lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0"
    }, [_c('a', {
      staticClass: "font-medium",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(socialreason.name) + " - " + _vm._s(socialreason.country_prefix))])]), _vm._v(" "), _c('div', {
      staticClass: "flex -ml-2 lg:ml-0 lg:justify-end mt-3 lg:mt-0"
    }, [_c('a', {
      staticClass: "pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 zoom-in text-white",
      on: {
        "click": function($event) {
          return _vm.removeElement(socialreason, 'suppliersocialreason')
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "minus",
        "classname": "w-4 h-4 mr-2"
      }
    })], 1)])])])])
  }), 0), _vm._v(" "), (_vm.filteredSocialReasons.length) ? _c('div', {
    staticClass: "intro-y flex flex-col-reverse mt-3 sm:flex-row items-center"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-2"
  }, [_vm._v("\n            Razones Sociales Sin Asignar\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-3 mt-5"
  }, _vm._l((_vm.filteredSocialReasons), function(socialreason, index) {
    return _c('div', {
      key: index,
      staticClass: "intro-y col-span-12 md:col-span-6"
    }, [_c('div', {
      staticClass: "box bg-gray-300"
    }, [_c('div', {
      staticClass: "flex flex-col lg:flex-row items-center p-5 border-b border-gray-200"
    }, [_c('div', {
      staticClass: "lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0"
    }, [_c('a', {
      staticClass: "font-medium",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(socialreason.name) + " - " + _vm._s(socialreason.country_prefix))])]), _vm._v(" "), _c('div', {
      staticClass: "flex -ml-2 lg:ml-0 lg:justify-end mt-3 lg:mt-0"
    }, [_c('a', {
      staticClass: "bg-gray-100 border flex h-8 items-center justify-center ml-2 pl-2 rounded-full w-8 zoom-in",
      on: {
        "click": function($event) {
          return _vm.addElement(socialreason, 'suppliersocialreason')
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "plus",
        "classname": "w-4 h-4 mr-2"
      }
    })], 1)])])])])
  }), 0)])]) : _c('app-loading')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae504928","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/suppliers/RelationsSupplier.vue
// module id = 470
// module chunks = 1